import resolve from "ioc/resolve";

const DEFAULT_CLASS = "emun";
export const ASIDES = ["left", "right", "top", "bottom"];
export const isAside = ({ placement } = {}) => ASIDES.indexOf(placement) >= 0;
export const removeClass = (className = DEFAULT_CLASS) =>
  console.debug("removeClass", className) ||
  document.body.classList.remove(className);
export const addClass = (className = DEFAULT_CLASS) =>
  console.debug("addClass", className) ||
  document.body.classList.add(className);

export default (options = {}) => {
  const modalProvider = isAside(options) ? "$aside" : "$uibModal";
  const provider = resolve(modalProvider);
  addClass(); // PLUGIN
  const instance = provider.open(options);
  // console.debug("modalProvider", {
  //   modalProvider,
  //   options,
  //   provider,
  //   instance,
  // });
  instance.result.finally(() => removeClass(DEFAULT_CLASS)); // PLUGIN
  return instance;
};
